import { APITypes } from 'plyr-react'
import * as React from 'react'
import { Media } from '../../cms/blocks/utils/media.mod'

type VideoProvider = 'youtube' | 'vimeo'

export type VideoLightboxProps = {
  videoURL: string
  provider: VideoProvider
  buttonText: string
  closeText: string
}
export const VideoLightbox = (props: VideoLightboxProps) => {
  const { buttonText, closeText, videoURL } = props
  const containerRef = React.useRef<HTMLElement>(null)
  const plyrRef = React.useRef<APITypes>(null)

  return (
    <>
      <button onClick={() => playVideo(containerRef, plyrRef)} className="button button--video">
        <span className="button__text">{buttonText}</span>
      </button>
      <aside className="lightbox lightbox--hidden" ref={containerRef}>
        <div className="lightbox__inner">
          <div className="lightbox__bg" onClick={() => pauseVideo(containerRef, plyrRef)} />
          <nav className="lightbox__nav">
            <div className="lightbox__nav-inner">
              <button onClick={() => pauseVideo(containerRef, plyrRef)} className="lightbox__close">
                <span className="sr-text">{closeText}</span>
                <img className="languages__logo" src="/images/icons/icon--close--white.svg" alt="" height="30" width="32"/>
              </button>
            </div>
          </nav>
          <div className="lightbox__visual">
            <div className="lightbox__video">
              <Media kind="media" url={videoURL} useCookiebar plyrRef={plyrRef} />
            </div>
          </div>
        </div>
      </aside>
    </>
  )
}

const playVideo = (containerRef: React.RefObject<HTMLElement>, plyrRef: React.MutableRefObject<APITypes>) => {
  const container = containerRef.current
  const plyr = plyrRef.current
  console.log('test play', containerRef, plyrRef)
  if (container && plyr) {
    document.documentElement.classList.add('lightbox--open')
    container.classList.remove('lightbox--hidden')
    setTimeout(() => {
      if (plyr.plyr) {
        plyr.plyr.play()
      }
    }, 0)
  }
}

const pauseVideo = (containerRef: React.RefObject<HTMLElement>, plyrRef: React.MutableRefObject<APITypes>) => {
  const container = containerRef.current
  const plyr = plyrRef.current
  console.log('test pause', containerRef, plyrRef)
  if (container && plyr) {
    document.documentElement.classList.remove('lightbox--open')
    container.classList.add('lightbox--hidden')
    if (plyr.plyr) {
      plyr.plyr.pause()
    }
  }
}
